import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InfluencerSuggestion, InfluencerSuggestionState} from '../../../../models/influencer-suggestion';
import {GroupService} from '../../../services/group-details/group.service';
import {Platform} from '../../../../models/platform';
import {Campaign} from '../../../../models/campaign';
import {CampaignService} from '../../../services/campaign/campaign.service';
import {TranslateService} from '@ngx-translate/core';
import {AddInfluencerGroupComponent} from '../../group-details/add-influencer-group/add-influencer-group.component';
import {Country} from '../../../../models/country';
import {UserService} from '../../../services/user.service';
import {ModalService} from '../../../services/modal/modal.service';
import {PlaceholderVisibilityService} from '../../../services/placeholder-visibility/placeholder-visibility.service';
import {CommonConstant} from '../../../app.constants';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {EventTrackerService} from '../../../services/event-tracker/event-tracker.service';

@Component({
  selector: 'add-influencer-campaign',
  templateUrl: './add-influencer-campaign.component.html',
  styleUrls: ['./add-influencer-campaign.component.scss']
})
export class AddInfluencerCampaignComponent extends AddInfluencerGroupComponent implements OnInit {
  @Input()
  public platformList: Platform[];
  @Input()
  public countryList: Country[];
  @Input()
  public isShowAddInfluencerToCampaignsFragment: boolean | false;
  @Input()
  public campaign: Campaign | null;
  @Input()
  public isAddImmediately = true;
  @Input()
  public initializeInfluencerList: any;
  @Input()
  public addInfluencerAsAccepted = false;
  @Output()
  public eventAddInfluencerToCampaigns: EventEmitter<any> = new EventEmitter<any>();

  constructor(private campaignService: CampaignService,
              private groupService2: GroupService,
              protected userService: UserService,
              protected modalService: ModalService,
              protected influencerService: InfluencerService,
              protected translate: TranslateService,
              protected eventTracker: EventTrackerService) {
    super(groupService2, userService, translate, influencerService, eventTracker, modalService);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.initializeInfluencerList && this.initializeInfluencerList.length > 0) {
      const addedInfluencerIds = this.selectedInfluencers.map(si => si.influencerId);
      this.initializeInfluencerList.forEach((infl) => {
        if (addedInfluencerIds.indexOf(infl.influencerId) < 0) {
          this.selectedInfluencers.push(infl);
        }
      });
      this.addInfluencerAsAccepted = this.initializeInfluencerList.filter((influencer) =>
        influencer.status.toLowerCase() !== CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name.toLowerCase()).length === 0;
    }
  }

  selectInfluencerSuggestion(influencer: InfluencerSuggestion) {
    super.selectInfluencerSuggestion(influencer);
  }

  closeAddInfluencerToCampaign(evt) {
    this.closeConfirmationPopup();
    this.closeFragmentEvent.emit({
      resetSelectedInfluencer: true
    });
  }

  public validateInfluencerListBeforeAddToCampaign() {
    const incompletedInfluencers = this.selectedInfluencers.filter(infl => infl.state === InfluencerSuggestionState.NOT_FOUND);
    if (incompletedInfluencers.length > 0) {
      this.modalService.openInCenter(this.warningForAddingNewInfluencer);
    } else {
      this.addInfluencerToCampaign();
    }
  }

  public addNewInfluencer(evt) {
    this.addNewInfluencerManuallyEvent.emit({
      handle: evt.handle,
      processingIndex: evt.index,
      influencerSuggestion: evt.influencer,
      selectedInfluencers: this.selectedInfluencers,
      addInfluencerAsAccepted: this.addInfluencerAsAccepted
    });
  }

  addInfluencerToCampaign() {
    const campaignInfluencers = this.selectedInfluencers.filter(inf => inf.influencerId > 0)
      .map((influencer) => Object.assign({}, influencer, {
        influencer_id: influencer.influencerId,
        action: 'add',
        status: this.addInfluencerAsAccepted ? CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name : ''
    }));
    if (!this.isAddImmediately) {
      this.eventAddInfluencerToCampaigns.emit(campaignInfluencers);
    } else {

      const influencerToAdd = {
        influencers: campaignInfluencers,
        campaign_id: this.campaign.id
      };
      this.eventAddInfluencerToCampaigns.emit(influencerToAdd);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/campaigns/add-influencer-campaign/add-influencer-campaign.component.ts